import { Button, Grid, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from '../../../../../../UiComponents/Cards/MainCard';
import WebinarDetailsRight from './WebinarSummaryRight';
import { useParams } from 'react-router-dom';
import WebinarSummaryLeft from './WebinarSummaryLeft';
import { catchErr } from '../../../../../../libs/HelperContent';
import { getMeetingsList, updateMeeting } from '../../../../../actions/meeting_actions';
import { toast } from 'react-toastify';
import axios from 'axios';

const WebinarDetailing = (props) =>
{
	const { form:webinarData, handleBack, handleClose,
		setActiveStep, handleDeletePop, isCompletedRef } = props;
	const [ form, setForm ] = useState(webinarData);
	const { type } = useParams();
	const [ webinarDetails, setWebinarDetails ] = useState<any>({});

	const handleNavi = (number) =>
	{
		setActiveStep(number);
	};

	const handleFinish = async () =>
	{
		const body = {
			actionType     : 'updateWebinar',
			meetingDetails : { isCompleted: true },
			id             : form?.id
		};

		try
		{
			const res = await updateMeeting(body);

			if (type !== 'create')
			{
				await axios
					.post(`${process.env.REACT_APP_SERVER_CONFIG}updateMeet`, {
						sessionId : form?.id,
						meetInfo  : webinarDetails
					});
			}

			if (res?.status)
			{
				isCompletedRef.current = true;
				toast.success(`Webinar has been ${type === 'create' ? 'created' : 'updated'} succcessfully`, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
				handleClose();
			}
		}
		catch (err)
		{
			catchErr(err);
		}
	};

	const getWebinarData = async () =>
	{
		try
		{
			const queryParams:any = {
				id   : form?.id,
				type : 'webinar'

			};

			const res = await getMeetingsList(queryParams);

			if (res?.status)
			{
				const wData = { ...res?.data, ...res?.data?.meetingDetails };
				const newEditObj = {
					id : wData?._id,
					...wData,
					...wData?.permissions
					// password : {
					// 	isPassword      : Boolean(wData?.meetingPassword),
					// 	meetingPassword : wData?.meetingPassword
					// }
					// metaData : { externalMembers: webinarData?.shareTo.filter((item) => emailPattern.test(item)) }
					// chage later for external members
				};

				setWebinarDetails({ ...res?.data?.meetingDetails });

				delete newEditObj.meetingDetails;
				setForm(newEditObj);
			}
			else
			{
				setForm({});
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log('======================>', err);
		}
	};

	useEffect(() =>
	{
		getWebinarData();
	}, []);

	return (

		<Grid container>
			<MainCard>
				<Grid container direction={'row'} xs={12} spacing={1}>
					{/* Left Part of Preview */}
					<WebinarSummaryLeft form={form} handleNavi={handleNavi}/>
					<Grid item xs={12} lg={8}>
						{/* Right Part of Preview */}
						<WebinarDetailsRight form={form} handleNavi={handleNavi}/>
					</Grid>
				</Grid>
				<Stack direction='row' justifyContent={'space-between'} pt='var(--pixel16)'>
					<Button variant='outlined' onClick={handleBack}>Previous</Button>
					<Stack direction={'row'} spacing={2}>
						<Button variant='outlined' onClick={handleDeletePop}>Cancel</Button>
						<Button variant='contained' sx={{ color: 'var(--whiteColor)' }} onClick={handleFinish}>Finish</Button>
					</Stack>
				</Stack>
			</MainCard>
		</Grid>

	);
};

export default WebinarDetailing;
